import React from "react";
import danger from "../../assets/popup/Danger.png";

const DelConfirmPopup = ({ visible, delSelectedId, doctype, message, onConfirm, onCancel, alredysubmitdata, delDone }) => {
  if (!visible) return null;

  return (
    <div className="popup-overlay fixed inset-0 flex items-center justify-center bg-black/40 z-50">
      <div className="popup-container relative bg-white rounded-xl shadow-lg w-96 p-6 text-center">

        <button
          className="popup-close absolute top-2 right-3 text-2xl text-gray-500 hover:text-gray-700"
          onClick={onCancel}
        >
          ×
        </button>

        <div className="blue-half-circle flex justify-center mb-4">
          <img src={danger} alt="Popup Icon" className="popup-image w-14 h-14" />
        </div>

        <div className="popup-content">
          <h4 className="text-xl font-semibold" style={{ color: "#823455" }}>
            {delDone
              ? "Deleted Successfully"
              : (alredysubmitdata ? "Error in Delete" : "Delete Confirmation")}

          </h4>
          {!alredysubmitdata && !delDone && (<strong>{delSelectedId}</strong>)}
          <p className=" small text-muted">

            {message || `Are you sure you want to delete ${doctype} `}

          </p>

          {!alredysubmitdata && !delDone && (
            <div className="popup-buttons mt-4 flex justify-around">
              <button
                className="popup-btn cancel-btn bg-gray-300 text-black  hover:bg-gray-400"
                onClick={onCancel}
              >
                Cancel
              </button>
              <button
                className="popup-btn submit-btn bg-red-500 text-white  hover:bg-red-600"
                onClick={onConfirm}
              >
                Delete
              </button>
            </div>
          )}


        </div>
      </div>
    </div>
  );
};

export default DelConfirmPopup;
